import GradingLayout from 'pages/Grading/PageLayout';
import Desktop from 'pages/QuizGrading/desktop';
import Mobile from 'pages/QuizGrading/mobile';
import Tablet from 'pages/QuizGrading/tablet';

const layouts = { desktop: Desktop, mobile: Mobile, tablet: Tablet };
const PageLayout = () => (
    <GradingLayout
        renderLayout={(device, props) => {
            const Layout = layouts[device];
            return <Layout {...props} />;
        }}
    />
);

export default PageLayout;
